export enum PositionEnum {
  TopLeft = "topLeft",
  BottomLeft = "bottomLeft",
  TopCenter = "topCenter",
  BottomCenter = "bottomCenter",
  TopRight = "topRight",
  BottomRight = "bottomRight",
}
